import { render, staticRenderFns } from "./SalarySheetCreate.vue?vue&type=template&id=2ad36aaa"
import script from "./SalarySheetCreate.vue?vue&type=script&lang=js"
export * from "./SalarySheetCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports